import { HStack, IconButton, Text } from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';

import FormBase from 'components/forms/new/FormBase';
import AddBlockContent from './components/AddBlockContent';
import SubmitProgressModal from './components/SubmitProgressModal';
import { useAddNumberBlock } from './hooks/useAddNumberBlock';

/*
 * Component when Number Blocks Add component is selected
 * Performs the addition logic/form for the number block component
 */
export default function AddNumberBlockModal({ onBack, onGoToOrders }) {
    const {
        aggregateTable,
        updateAggregateTable,
        hasError,
        setHasError,
        hasEmptyNumber,
        setHasEmptyNumber,
        isProcessing,
        initialValues,
        handleModalSubmit,
        handleFieldValueChange,
        onError,
        uploadMethod,
        setUploadMethod,
        isCreateOrderWholesaler,
        selectedUsage,
        countryMismatchRows,
        isOpen,
        onClose,
        chunkProgress,
        chunkResults,
        isOrderSubmit,
        orderResult,
        darkMode,
        requiredScope,
        dispatch,
        isCarrierRequired,
        setCarrierCount,
    } = useAddNumberBlock();

    return (
        <>
            <HStack spacing={3} mb={4} alignItems="center">
                <IconButton
                    aria-label="Back to Number Blocks"
                    icon={<ArrowBackIcon />}
                    variant="ghost"
                    size="sm"
                    onClick={() => {
                        dispatch({ type: 'CLOSE_MODAL' });
                        dispatch({ type: 'RESET_MODAL' });
                    }}
                />
                <Text sx={{ fontSize: '20', fontWeight: '500' }}>
                    Add Number Block
                </Text>
            </HStack>

            <FormBase
                initialValues={initialValues}
                finalFormSubmit={async (values, actions) => {
                    try {
                        await handleModalSubmit(values);
                        // Don't call onSuccess() - stay on page to show summary
                    } finally {
                        actions.setSubmitting(false);
                    }
                }}
                onBack={() => onBack()}
                customClick={true}
                tabMode={true}
                enableReinitialize={true}
                isSubmitDisabled={
                    hasError ||
                    hasEmptyNumber ||
                    isProcessing ||
                    isCarrierRequired ||
                    (isCreateOrderWholesaler && !selectedUsage) ||
                    countryMismatchRows.length > 0
                }>
                {(formProps) =>
                    AddBlockContent({
                        ...formProps,
                        darkMode,
                        requiredScope,
                        handleFieldValueChange,
                        onError,
                        onCarriersLoaded: setCarrierCount,
                        aggregateTable,
                        updateAggregateTable,
                        hasError,
                        setHasError,
                        hasEmptyNumber,
                        setHasEmptyNumber,
                        uploadMethod,
                        setUploadMethod,
                        isCreateOrderWholesaler,
                        countryMismatchRows,
                    })
                }
            </FormBase>

            <SubmitProgressModal
                isOpen={isOpen}
                onClose={onClose}
                isProcessing={isProcessing}
                chunkProgress={chunkProgress}
                chunkResults={chunkResults}
                isOrderSubmit={isOrderSubmit}
                orderResult={orderResult}
                onGoToOrders={onGoToOrders}
                darkMode={darkMode}
            />
        </>
    );
}
